import PropTypes from "prop-types";
import { memo } from "react";
import { useSelector } from "react-redux";

import {
  ELEVATOR_ALL_INOPERABLE,
  ELEVATOR_ALL_OPERABLE,
  ELEVATOR_AT_LEAST_ONE_INOPERABLE,
  ELEVATOR_AT_LEAST_ONE_UNKNOWN,
} from "../constants";
import { enumElevatorState } from "../model/propTypes";

import {
  Elevator,
  ElevatorBroken,
  ElevatorGray,
  ElevatorYellow,
} from "./icons";

const propTypes = {
  elevatorOutOfOrder: PropTypes.bool,
  elevatorState: enumElevatorState,
};

/**
 * Display an elevator status icon depending on station's properties.
 */
function StationIconElevator({ elevatorOutOfOrder, elevatorState }) {
  const config = useSelector((state) => state.config?.stationIcons);
  let elevator = null;
  if (config.hasElevatorState) {
    switch (elevatorState) {
      case ELEVATOR_ALL_INOPERABLE:
        elevator = <ElevatorBroken data-testid="elevator-broken-icon" />;
        break;
      case ELEVATOR_AT_LEAST_ONE_INOPERABLE:
        elevator = <ElevatorYellow data-testid="elevator-yellow-icon" />;
        break;
      case ELEVATOR_AT_LEAST_ONE_UNKNOWN:
        elevator = <ElevatorGray data-testid="elevator-gray-icon" />;
        break;
      case ELEVATOR_ALL_OPERABLE:
      default:
        elevator = <Elevator data-testid="elevator-icon" />;
        break;
    }
  } else if (config.hasElevatorOutOfOrder) {
    elevator = elevatorOutOfOrder ? (
      <ElevatorBroken data-testid="elevator-broken-icon" />
    ) : (
      <Elevator data-testid="elevator-icon" />
    );
  }
  return elevator;
}

StationIconElevator.propTypes = propTypes;

export default memo(StationIconElevator);
